import React from "react";
import { Accordion } from "react-bootstrap";

import { DstAccordionProps } from "./DstAccordion.d";
import "./DstAccordion.scss";

const DstAccordion = ({ icon, title, text, textRight, eventKey = "0" }: DstAccordionProps) => (
  <Accordion defaultActiveKey={null} className="dst-accordion mb-3">
    <Accordion.Item eventKey={eventKey}>
      <Accordion.Header>
        <div className="d-flex justify-content-between align-items-center w-100 s-regular">
          <div className="d-flex align-items-center">
            <div className="me-2 blue-font">{icon}</div>
            <div>{title}</div>
          </div>
          <div className="d-flex align-items-center">
            <div>{textRight}</div>
            <span className="dst-icon-chevron-down blue-font rotate-icon ms-2 s-bold" />
          </div>
        </div>
      </Accordion.Header>
      <Accordion.Body>{text}</Accordion.Body>
    </Accordion.Item>
  </Accordion>
);
export default DstAccordion;
